exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".variant-metadata-wrapper[data-v-463c7d0e]{display:inline-block;text-align:left}.variant-metadata-wrapper .metadata-item .metadata-name[data-v-463c7d0e]{font-weight:700}.variant-metadata-wrapper .metadata-item .variant-metadata-info[data-v-463c7d0e]{position:absolute;z-index:9999999;display:none;background-color:#fff;padding:20px;border-radius:10px;max-width:400px;box-shadow:0 1px 4px rgba(0,0,0,.16);white-space:pre-wrap}.variant-metadata-wrapper .metadata-item .info-icon-wrapper:active .variant-metadata-info[data-v-463c7d0e],.variant-metadata-wrapper .metadata-item .info-icon-wrapper:hover .variant-metadata-info[data-v-463c7d0e]{display:block}@media screen and (max-width:480px){.variant-metadata-wrapper[data-v-463c7d0e]{text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-463c7d0e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/SeatPicker/metadata-info.vue
// module id = QXeX
// module chunks = 116